export const API_BASE_URL = process.env.REACT_APP_BASE_DOMAIN || '';

export function getApiOrigin() {
  try {
    return API_BASE_URL ? new URL(API_BASE_URL).origin : window.location.origin;
  } catch (_) {
    return window.location.origin;
  }
}

export function getWsUrl(path = '/') {
  const origin = getApiOrigin();
  const url = new URL(origin);
  const wsOrigin = `${url.protocol === 'https:' ? 'wss:' : 'ws:'}//${url.host}`;
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${wsOrigin}${normalizedPath}`;
}
